import React, { useRef, useState } from 'react'
import { Layout } from './styles'
import { message } from '~/services'
import { IFetalDiagnosis } from '~/interfaces'

import { Input, Table } from '~/components/shared'
import { useFetalDiagnoses } from '~/context'
import { transformDate } from '~/utils'
import { useNormalizedFilter } from '~/hooks'

interface FetalDiagnosesListProps {
  diagnoses: IFetalDiagnosis[]
}

export const FetalDiagnosesList = ({ diagnoses }: FetalDiagnosesListProps): JSX.Element => {
  const { filter } = useNormalizedFilter()
  const inputFilter = useRef<HTMLInputElement>(null)
  const [allowRefresh, setAllowRefresh] = useState(false)
  const { isLoading, errorMessage } = useFetalDiagnoses()
  const [descriptionFilter, setDescriptionFilter] = useState('')

  const filterByDescription = (diagnoses: IFetalDiagnosis[]): IFetalDiagnosis[] => {
    const isFilterEmpty = descriptionFilter === ''
    if (isFilterEmpty) return diagnoses

    return filter(diagnoses, {
      filterKey: 'description',
      searchTerm: descriptionFilter
    })
  }

  const handleSearch = event => {
    if (event.target.value !== '') {
      setAllowRefresh(true)
    }
    setDescriptionFilter(event.target.value)
  }

  const handleRefresh = () => {
    setDescriptionFilter('')
    inputFilter.current!.value = ''
    setAllowRefresh(false)
  }

  const fetalDiagnosisFormattedDate = ({ date }) => <>{transformDate({ date })}</>

  return (
    <Layout>
      <Input
        icon="search"
        ref={inputFilter}
        name="search_diagnosis"
        onChange={handleSearch}
        placeholder="Pesquisar diagnóstico"
      />
      <Table
        data={filterByDescription(diagnoses)}
        messageError={errorMessage ?? message('fetalDiagnoses.search_not_found')}
        isLoading={isLoading}
        headerLineHeight="30px"
        headerPadding="10px 0 10px 24px"
        minHeight="0px"
        onRefresh={allowRefresh ? handleRefresh : undefined}
        model={[
          {
            key: 'description',
            label: message('fetalDiagnoses.description').toUpperCase(),
            sortable: true
          },
          {
            key: 'bodyPart',
            label: message('fetalDiagnoses.body_part').toUpperCase(),
            sortable: true,
            width: '200px'
          },
          {
            key: 'date',
            label: message('fetalDiagnoses.date').toUpperCase(),
            sortable: true,
            width: '170px',
            Component: fetalDiagnosisFormattedDate
          }
        ]}
      />
    </Layout>
  )
}
